module.exports = __webpack_public_path__ + "media/images/salon-mobile-9c591648a787fd3372455749e8f5930b.png";